import {
    NEW_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    TABLE_VENDA_PRODUCAO_AGRICOLA_PENDING,
    TABLE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    TABLE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
    LIST_VENDA_PRODUCAO_AGRICOLA_PENDING,
    LIST_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    LIST_VENDA_PRODUCAO_AGRICOLA_FAILURE,
    FIND_VENDA_PRODUCAO_AGRICOLA_PENDING,
    FIND_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    FIND_VENDA_PRODUCAO_AGRICOLA_FAILURE,
    DELETE_VENDA_PRODUCAO_AGRICOLA_PENDING,
    DELETE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    DELETE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
    CREATE_VENDA_PRODUCAO_AGRICOLA_PENDING,
    CREATE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    CREATE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
    NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_PENDING,
    NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_FAILURE,
    NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_PEDING,
    NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
    NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_SUCCESS_PDF,
    NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_FAILURE
} from './actionTypes';


const initialState = { list: null, loading: false }


function vendaProducaoAgricolaReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_VENDA_PRODUCAO_AGRICOLA_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_VENDA_PRODUCAO_AGRICOLA_PENDING:
        case FIND_VENDA_PRODUCAO_AGRICOLA_PENDING:
        case DELETE_VENDA_PRODUCAO_AGRICOLA_PENDING:
        case CREATE_VENDA_PRODUCAO_AGRICOLA_PENDING:
        case TABLE_VENDA_PRODUCAO_AGRICOLA_PENDING:
            case NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_PEDING:
            case NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_VENDA_PRODUCAO_AGRICOLA_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_VENDA_PRODUCAO_AGRICOLA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_VENDA_PRODUCAO_AGRICOLA_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_VENDA_PRODUCAO_AGRICOLA_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_VENDA_PRODUCAO_AGRICOLA_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_VENDA_PRODUCAO_AGRICOLA_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_VENDA_PRODUCAO_AGRICOLA_SUCCESS: {
            return {
                ...state,
                xmlReaded: null,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_VENDA_PRODUCAO_AGRICOLA_SUCCESS_PDF:
            return {
                ...state,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_VENDA_PRODUCAO_AGRICOLA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_VENDA_PRODUCAO_AGRICOLA_SUCCESS:
        case CREATE_VENDA_PRODUCAO_AGRICOLA_FAILURE:
            return {
                ...state,
                loading: false,
                xmlReaded: null,
                registro: action.registro
            }
        case DELETE_VENDA_PRODUCAO_AGRICOLA_FAILURE:
            return {
                ...state,
                xmlReaded: null,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { vendaProducaoAgricolaReducer };